module.exports = __webpack_public_path__ + "assets/img/kv-189605d6.png";